import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { UserServiceApiService } from './user-service-api.service'

@Injectable({
  providedIn: 'root',
})
export class DerivedCountryService {
  public endpoint = 'v3/derived_country'

  constructor(
    private api: UserServiceApiService,
  ) {
    // noop
  }

  public show(): Observable<any> {
    const url = `${this.endpoint}/show`
    return this.api.get<any>(
      url
    ).pipe(
      map(response => response.result)
    )
  }
}
